export const isOverlappingBerth = (
  qmmFrom: number,
  qmmTo: number,
  berthQmmFrom: number,
  berthQmmTo: number,
) => {
  return berthQmmFrom < qmmTo && berthQmmTo > qmmFrom
}
